module.exports = __webpack_public_path__ + "assets/images/GBP20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/GBP20.png
// module id = 1380
// module chunks = 1